import React, { useState } from "react";
import { Button } from "@ts-digital/vrc";
import { Tooltip } from "antd";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import DeleteModal from "../deleteModal";

const BottomBar = ({ handleSubmit, lastUpdateTime, goBackToList }) => {
  const intl = useIntl();
  const isButtonActive = useSelector((state) => state.precog?.invoiceDetail?.data?.draftStatus?.isConfirmable) || false;
  const buttonDisableMessage = useSelector((state) => state.precog?.invoiceDetail?.data?.draftStatus?.message) || "";
  const buttonDisableMessageCode = useSelector((state) => state.precog?.invoiceDetail?.data?.draftStatus?.messageCode) || "";
  const data = useSelector((state) => state.precog?.invoiceDetail?.data);

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [spinnerDelete, setSpinnerDelete] = useState(false);

  let lastString = "";
  if (lastUpdateTime === "alcuni secondi fa") {
    lastString = useIntl().formatMessage({ id: "preCog.bottomBar.saveTime" });
  } else {
    lastString = lastUpdateTime;
  }

  return (
    <div
      className="pre-cog-nuovo-bottomBar"
      style={{
        left: 100,
        justifyContent: "space-between",
        padding: "40px 20px",
      }}
    >
      {/* https://teamsystem.atlassian.net/browse/DOP-1784
      <Button kind="secondary" onClick={() => goBackToList()}>
        <FormattedMessage id="preCog.bottomBar.goBack" />
      </Button>
      */}
      <div></div>
      <div style={{ display: "flex", gap: 20 }}>
        {lastUpdateTime && <div className="pre-cog-nuovo-bottomBar-text">{`Salvato ${lastString}`}</div>}
        {data?.source !== "B2B" && (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }} onClick={() => setOpenDeleteModal(true)}>
            <div className="arrow-container">
              <FontAwesomeIcon icon={["far", "trash-alt"]} style={{ color: "#0090d1", cursor: "pointer" }} />
            </div>
            <p className="change-text">
              <FormattedMessage id="preCog.accountingTab.delete" />
            </p>
          </div>
        )}
        <Tooltip
          color={"rgb(0, 80, 117)"}
          title={
            buttonDisableMessageCode
              ? intl.formatMessage({ id: `preCog.draftStatusMessage.${buttonDisableMessageCode}`, defaultMessage: buttonDisableMessage })
              : null
          }
          placement="top"
          trigger="hover"
          getPopupContainer={(trigger) => trigger.parentNode}
        >
          <div style={{ display: "flex" }}>
            <Button className="gs-precog-contabilizza" onClick={handleSubmit} disabled={!isButtonActive}>
              <FormattedMessage id="preCog.bottomBar.confirm" />
            </Button>
          </div>
        </Tooltip>
      </div>
      <DeleteModal
        visible={openDeleteModal}
        onClose={() => {
          setOpenDeleteModal(false);
        }}
        onClick={() => {
          setOpenDeleteModal(false);
        }}
        spinnerDelete={spinnerDelete}
        setSpinnerDelete={setSpinnerDelete}
        setOpenDeleteModal={setOpenDeleteModal}
        data={data}
        navigateTo={true}
      />
    </div>
  );
};

export default BottomBar;
